import React from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import { getUserList } from "../../api/support";
import { UserList } from "../../types/types";
import UserEditModal from "../../components/modals/UserInfoModal";
import { DatePicker } from "@mui/x-date-pickers";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../components/common/FormFields";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import adminSurface from "../../components/layouts/AdminSurface.module.css";
import studio from "../../styles/studioPage.module.css";

const UsersSupp: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const [startDate, setStartDate] = React.useState<Date | null>(null);
    const [endDate, setEndDate] = React.useState<Date | null>(null);
    const [userList, setUserList] = React.useState<UserList>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [userId, setUserId] = React.useState<string>("");
    const [showEditModal, setShowEditModal] = React.useState<boolean>(false);

    const fetchUserList = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                console.error("Token not found");
                return;
            }

            if (!startDate || !endDate) {
                console.error("Start date and end date are required");
                return;
            }
            const response = await getUserList(token, startDate, endDate);
            setUserList(response);
        } catch (error) {
            console.error("Failed to fetch businessCatalogs", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={adminSurface.pageContent}>
            <div className={`${studio.pageTitle} ${adminSurface.pageTitle}`}>
                <TitleSubtitle title={t("userList")} subtitle={t("userListSubTitle")} />
            </div>

            <div className={`${adminSurface.supportFilterBar} ${adminSurface.dateFilterForm}`}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <ThemeProvider theme={theme}>
                        <div className={adminSurface.supportDateFl}>
                            <label>{t("startDate")}</label>
                            <DatePicker value={startDate} onChange={(e) => setStartDate(e)} />
                        </div>
                        <div className={adminSurface.supportDateFl}>
                            <label>{t("endDate")}</label>
                            <DatePicker value={endDate} onChange={(e) => setEndDate(e)} />
                        </div>
                    </ThemeProvider>
                </LocalizationProvider>
                <button
                    className={adminSurface.addButton}
                    onClick={fetchUserList}
                    disabled={loading || !startDate || !endDate}
                >
                    {loading ? t("loading") : t("submit")}
                </button>
            </div>

            <div className={`${adminSurface.tableContainer} ${adminSurface.tblScrollSupport}`}>
                <table className={adminSurface.table}>
                    <thead>
                        <tr>
                            <th>{t("firstname")}</th>
                            <th>{t("lastname")}</th>
                            <th>{t("email")}</th>
                            <th className={adminSurface.colAct}>{t("actions")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userList.map((user) => (
                            <tr key={user.id}>
                                <td>{user.firstname}</td>
                                <td>{user.lastname}</td>
                                <td className={adminSurface.supportEmail}>{user.email}</td>
                                <td className={adminSurface.colAct}>
                                    <div className="cities-table-actions">
                                        <button
                                            className={adminSurface.supportBtnMore}
                                            onClick={() => {
                                                setUserId(user.id);
                                                setShowEditModal(true);
                                            }}
                                        >
                                            {t("seeMore")}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {userId && <UserEditModal userId={userId} isOpen={showEditModal} onClose={() => setShowEditModal(false)} />}
        </div>
    );
};

export default UsersSupp;
